import script from "./notice.vue?vue&type=script&setup=true&lang=js"
export * from "./notice.vue?vue&type=script&setup=true&lang=js"

import "./notice.vue?vue&type=style&index=0&id=72948db5&lang=scss&scoped=true"

import exportComponent from "/Users/luoxuelin/Workspace/idea/wnzhfc/s-pages/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72948db5"]])

export default __exports__